import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh', // Takes full viewport height
        textAlign: 'center',
        padding: '20px',
        boxSizing: 'border-box',
      }}
    >
      <h1 style={{ marginBottom: '20px' }}>403 - Not Authorized</h1>
      <p style={{ marginBottom: '10px' }}>You do not have permission to view this page.</p>
      <p style={{ marginBottom: '20px' }}>
        If you believe this is a mistake, please contact your administrator.
      </p>
      <Link
        to="/backend"
        style={{
          textDecoration: 'none',
          color: 'blue',
          fontWeight: 'bold',
          padding: '10px 20px',
          border: '1px solid blue',
          borderRadius: '4px',
        }}
      >
        Go Back to Home
      </Link>
    </div>
  );
};

export default Unauthorized;
